import { ConfigType } from './types'

import { getCountryId } from './handlers/getSender/helpers/getCountryId'

let config: ConfigType = {}

const _resetConfig = () => {
  config = {}
}

const prepareConfig = async (inputConfig: ConfigType) => {
  const countryId = inputConfig.countryId || (await getCountryId(inputConfig.apiDomain || ''))

  return { ...config, ...inputConfig, ...(countryId ? { countryId } : {}) }
}

export const init = async (initialConfig: ConfigType) => {
  _resetConfig()
  config = await prepareConfig(initialConfig)
}

const get = async () => prepareConfig(config)

export const set = (additionalConfig: ConfigType) => {
  config = { ...config, ...additionalConfig }
}

export default { get, init, set }
